import { observer } from "mobx-react-lite";
import React from "react";
import { Header,  Segment } from "semantic-ui-react";
import styles from "../Home/AgeReadyScore/ModuleTasks/ModuleModal/TaskModalHeader.module.css"


const ComingSoonPlaceholder: React.FC = () => {
  return (
    <>
      <Segment basic className={styles.domainTaskSegment} >
        <div className={styles.domainTaskContent}>
          <Segment raised style={{margin: '4rem 2rem 2rem 2rem', padding: '3rem', backgroundColor: '#f0faf0e4', borderRadius: '2rem'}} >
            <Header style={{fontSize: '4rem', textAlign: 'center'}}> Coming Soon! </Header>
          </Segment> 
        </div>
      </Segment> 
    </>
  );
};

export default observer(ComingSoonPlaceholder);
